import React from "react";
import Criteria from "./Criteria";
import SmartListSelector from "../modules/SmartListSelector";
import { useObjectStore } from "../storez/ObjectStore";

export default class MacAddressObject extends React.Component {
  constructor(props, context) {
    super(props, context);

    if (props.criteria.conditions === undefined) {
      props.criteria.conditions = [];
    }

    this.state = {
      criteria: props.criteria,
      availableObjects: useObjectStore.getState().getMacObjects(),
    };

    /* {type: "source.mac.pool", negate: false, conditions: []} */
  }

  componentDidMount() {
    this.unsubscribe = useObjectStore.subscribe(this.onChange);

    setTimeout(() => {
      void useObjectStore.getState().fetch();
    }, 0);
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = undefined;
    }
  }

  onChange = () => {
    this.setState({
      availableObjects: useObjectStore.getState().getMacObjects(),
    });
  };

  componentWillReceiveProps(nextprops) {
    if (nextprops.criteria.conditions === undefined) {
      nextprops.criteria.conditions = [];
    }

    this.setState({
      criteria: nextprops.criteria,
    });
  }

  handle_Add = (item) => {
    this.state.criteria.conditions.push(item);
    this.props.bubbleMethod(this.state.criteria);
  };

  handle_Remove = (item) => {
    let new_conditions = [];
    for (let x of this.state.criteria.conditions) {
      if (x !== item) {
        new_conditions.push(x);
      }
    }

    this.setState({
      criteria: { ...this.state.criteria, conditions: new_conditions },
    });

    this.props.bubbleMethod(this.state.criteria);
  };

  getObjectId = (item) => {
    return item["id"];
  };

  getObjectName = (item) => {
    return item["name"];
  };

  render() {
    return (
      <Criteria label="Mac Objects" onRemove={() => this.props.handle_RemoveCriteria(this.state.criteria)}>
        <SmartListSelector
          get__value={this.getObjectId}
          get__label={this.getObjectName}
          selected={this.state.criteria.conditions}
          available={this.state.availableObjects}
          removeSelectedFromOptions
          addElement={this.handle_Add}
          removeElement={this.handle_Remove}
        />
      </Criteria>
    );
  }
}
